<template>
  <v-container fluid>
    <page-header>
      <template slot="topRightSlot">
        <v-btn
          depressed
          elevation="0"
          class="ml-2 mb-4"
          color="primary"
          type="button"
          :to="{ name: 'CreateUser' }"
          >{{ $t('menu.createUser') }}</v-btn
        >
      </template>
    </page-header>

    <datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :itemTotal="tableTotal"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      actionViewRouteLink="UserDetail"
      @options-update="getList()"
      enableSearch
      enableClearAll
      searchPlaceholder="companySearchPlaceholder"
      @search-clicked="search($event)"
      @all-search-cleared="clearSearch()"
    >
      <template v-slot:[`item.known_from`]="{ item }">{{
        item.known_from ? $t(`knownFromOption.${item.known_from}`) : ''
      }}</template>
    </datatable>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
export default {
  name: 'UserList',
  components: {
    Datatable,
  },
  data: vm => ({
    tableLoading: false,
    tableData: [],
    tableTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
      keyword: '',
    },
    tableHeaders: [
      { value: 'create_date', text: vm.$t('registerDate'), width: 140 },
      { value: 'phone', text: vm.$t('phone') },
      { value: 'known_from', text: vm.$t('knownFrom') },
      { value: 'status', text: vm.$t('status') },
      { value: 'actionView', text: '', align: 'end' },
    ],
  }),
  methods: {
    async getList(regenUrl = true) {
      if (regenUrl) {
        this.regenerateURL()
      }

      this.tableLoading = true
      try {
        let payload = {
          filter_page: this.tableFilter.page - 1,
          filter_limit: this.tableFilter.limit,
        }
        if (this.tableFilter.keyword) {
          payload['search'] = this.tableFilter.keyword
        }
        const { total, data } = await this.$Fetcher.GetUsers(payload)
        this.tableTotal = total
        this.tableData = data.map(item => {
          return {
            id: item.id,
            create_date: item.create_date,
            phone: `(${item.zone}) ${item.phone}`,
            known_from: item.known_from.length ? item.known_from[0] : '',
            status: item.status,
          }
        })
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
      } finally {
        this.tableLoading = false
      }
    },
    search(value) {
      this.tableFilter.keyword = value
      this.tableFilter.page = 1
      this.getList()
    },
    clearSearch() {
      this.tableFilter.keyword = ''
      this.tableFilter.page = 1
      this.getList()
    },

    getQuery() {
      const query = this.$route.query
      if (Object.keys(query).length > 0) {
        if (this.$validate.DataValid(query.p) && this.$validate.regexNumber(query.p)) {
          this.tableFilter.page = parseInt(query.p)
        }

        if (this.$validate.DataValid(query.l) && this.$validate.regexNumber(query.l)) {
          this.tableFilter.limit = parseInt(query.l)
        }

        if (this.$validate.DataValid(query.q)) {
          this.tableFilter.keyword = query.q
        }
      }
    },
    regenerateURL() {
      const query = this.$route.query
      let q = {
        p: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        l: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
        q: this.tableFilter.keyword,
      }
      const newQuery = this.$common.diffQuery(q, query)
      if (newQuery) {
        this.$router.replace({ query: newQuery })
      }
    },
  },

  async mounted() {
    this.getQuery()
    this.getList(false)
  },
}
</script>
